import LoginForm from './container'

export default LoginForm
